<template>
  <div>
    <table class="ts-w-full">
      <tbody>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.projectCode') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.project_code }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.status') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.project_status }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.projectName') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.project_name }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.owner') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.owner_name_en }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.estimateStartDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.estimated_start_date }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.estimateEndDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.estimated_end_date }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.actualStartDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.actual_start_date }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.actualEndDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.actual_end_date }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.createdBy') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.created_by_name }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('milestone.createdAt') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resources.created_at }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: ['resources'],
  data() {
    return {
      defaultImage: require('@/assets/default-image.jpg')
    }
  },
  methods: {
    ...mapActions('projectMgt/projectMilestone', ['deleteAttachment']),
    onClickViewFile(att) {
      window.open(att.file_path, '_blank', 'noreferrer')
    },
    deleteRecord(id) {
      this.$confirm({
        title: this.$t('task.are_you_want_to_delete_it_cant_redo'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.deleteAttachment(id)
            .then(response => {
              this.$emit('fetch')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    }
  }
}
</script>
